import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useLinkBehavior } from '../shared';
import { SecondaryStyledLink } from '../styles';

/**
 * @deprecated - Start using {Link} component instead of this. We have sm and xs size available in Link component which is similar to this.
 */
var SecondaryLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTest = _ref['data-test'],
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      linkProps = _objectWithoutProperties(_ref, ["data-test", "size"]);

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  return /*#__PURE__*/React.createElement(SecondaryStyledLink, _extends({
    size: size
  }, linkProps, linkBehavior, {
    ref: ref,
    "data-test": dataTest ? dataTest : undefined
  }));
});
SecondaryLink.displayName = 'SecondaryLink';
export default SecondaryLink;